import axios from 'axios';

import { buildActionUrl, TYPE_PROJECT_BY_ID } from '../../../../shared/url';
import { ingredientToString } from '../../../../shared/utils';
import { IngredientDBIngredientType, ProjectType } from '../../../../types';

export interface StepDataResponse {
  project?: ProjectType;
}

/**
 * Fetch required for flow step basic data: project and phase info.
 *
 * @param get
 * @param projectId
 * @param phaseId
 * @param runId
 */
export async function loadFlowStepData(projectId: string): Promise<StepDataResponse> {
  const projectResult: { project?: ProjectType } = await axios
    .get(buildActionUrl({ projectId }, TYPE_PROJECT_BY_ID))
    .then((res) => res.data);

  if (projectResult?.project) {
    projectResult.project.workflowConfig = projectResult.project?.workflowConfig || [];
  }

  return {
    project: projectResult?.project,
  };
}

export class IngredientDBMap {
  ingredientMap: Map<number, IngredientDBIngredientType>;

  ingredients: IngredientDBIngredientType[];

  dropdownMap: Map<string, IngredientDBIngredientType>;

  dropdownIngredientIdMap: Map<number, string>;

  dropdownOptions: string[];

  version: string;

  constructor(ingredients: IngredientDBIngredientType[], version: string) {
    this.ingredients = ingredients;
    this.version = version;
    this.dropdownOptions = [];

    this.ingredientMap = new Map();
    ingredients.forEach((i) => {
      this.ingredientMap.set(Number(i.ingredientId), i);
    });

    this.dropdownMap = new Map();
    this.dropdownIngredientIdMap = new Map();
    ingredients.forEach((i) => {
      const ingredientString = ingredientToString<IngredientDBIngredientType>('ingredientId')(i);
      this.dropdownMap.set(ingredientString, i);
      this.dropdownIngredientIdMap.set(Number(i.ingredientId), ingredientString);
      this.dropdownOptions.push(ingredientString);
    });
  }

  searchIngredient(query: string): IngredientDBIngredientType | undefined {
    return this.dropdownMap.get(query);
  }

  searchIngredientById(ingredientId: number): IngredientDBIngredientType | undefined {
    return this.ingredientMap.get(ingredientId);
  }
}
